/* rd-expiry W2.1b — Frame 6 "Already booking" overlay. CSS copied from the
   confirmed mockup (docs/mockups/client-dashboard-redesign/session-recovery-states.html,
   Frame 6: .overlay / .ov-icon / .ov-title / .ov-sub / .ov-card / .rc-actions /
   .rc-btn[.ghost]). HONEST swap log (same discipline as SessionDetailPage.module.css):
     · var(--font-display)        → var(--client-font-heading), the theme's heading font (EB Garamond by default)
     · var(--r-md|pill)           → literal px (radii are not injected tokens)
   Every colour/glass/accent surface maps to an existing INJECTED foundation token
   (no :root hex block, no new tokens minted). */

/* Full-screen recovery overlay (pinned over the dimmed page underneath). */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 88;
  background: rgba(var(--bg-page-rgb), 0.92);
  backdrop-filter: blur(9px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 38px calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)));
  animation: afc-fade 0.22s ease;
}
@keyframes afc-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ovIcon {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-bottom: 22px;
}
.ovIcon svg {
  width: 38px;
  height: 38px;
}
.ovIcon.warm {
  background: rgba(var(--accent-rgb), 0.16);
  border: 1.5px solid rgba(var(--accent-rgb), 0.5);
  color: var(--accent-hot);
  box-shadow: 0 0 38px rgba(var(--accent-rgb), 0.28);
}

.ovTitle {
  font-family: var(--font-overlay-title, var(--client-font-heading, 'EB Garamond', Georgia, serif));
  font-weight: 600;
  font-size: 27px;
  color: var(--text-primary);
}
.ovSub {
  margin-top: 12px;
  font-size: 13.5px;
  color: var(--text-secondary);
  line-height: 1.55;
  max-width: 300px;
}

/* Existing-booking summary card (name stacked over date/time). */
.ovCard {
  margin-top: 20px;
  width: 100%;
  max-width: 320px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border-radius: 14px;
  background: var(--glass-bg-strong);
  border: 1px solid var(--border-soft);
  text-align: left;
}
.ovCard .thumb {
  width: 46px;
  height: 46px;
  border-radius: 11px;
  position: relative;
  background: rgba(var(--accent-rgb), 0.14);
  overflow: hidden;
  flex-shrink: 0;
}
/* The ring sits over the picture, as it did over the old background image. */
.ovCard .thumb::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  box-shadow: inset 0 0 0 1px rgba(var(--accent-rgb), 0.32);
  pointer-events: none;
}
/* The offering's picture, framed as the studio set it (website-photo-zoom). */
.ovCard .thumbImg {
  width: 100%;
  height: 100%;
}
.ovCard .meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.ovCard .meta .nm {
  font-family: var(--font-overlay-title, var(--client-font-heading, 'EB Garamond', Georgia, serif));
  font-weight: 600;
  font-size: 15px;
  color: var(--text-primary);
}
.ovCard .meta .wn {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
}

/* Recovery buttons. */
.rcActions {
  margin-top: 26px;
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.rcBtn {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border-radius: 14px;
  background: var(--accent-orb);
  color: var(--text-on-accent);
  font-size: 15.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  box-shadow: var(--glow-amber);
}
.rcBtn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
.rcBtn.ghost {
  background: var(--glass-bg-strong);
  border: 1px solid var(--border-soft);
  color: var(--text-secondary);
  box-shadow: none;
  font-weight: 600;
}
.rcBtn:disabled {
  opacity: 0.6;
  pointer-events: none;
}
